<template>
  <div class="invoice-info">
    <!-- 税率 -->
    <div class="tax-rate">
      <div class="tax-rate-title">
        <div class="invoice-info-title">税率</div>
        <div class="add-tax-rate" @click="addTaxRate">+添加税率</div>
        <div class="add-tax-rate" @click="saveTaxRate">保存税率</div>
      </div>
      <div class="tax-rate-content">
        <div class="tax-rate-row" v-for="(item, index) in taxRateList" :key="index">
          <div class="sort">{{ index+1 }}</div>
          <el-input v-model="item.taxRate" class="white" placeholder="请输入" @input="inputTaxRate(index, item.taxRate)">
            <span slot="suffix" class="tax-rate-unit">
              %
            </span>
          </el-input>
          <div class="del-tax-rate" v-if="index>0" @click="delTaxRate(index)">删除</div>
        </div>
      </div>
    </div>

    <!-- 汇率 -->
    <div class="invoice-info-title">汇率</div>
    <div class="exchange-rate">
      <el-input v-model="exchangeRate" class="white exchange-rate-input" placeholder="请输入"
        @input="inputExchangeRate(exchangeRate)">
      </el-input>
      <el-button class="btn-blue" @click="saveExchangeRate">保存</el-button>
    </div>

    <!-- 银行账号 -->
    <div class="invoice-info-title">银行账号</div>
    <div class="table">
      <el-table ref="table" :data="bankAccountNumberList" style="width: 100%" :row-class-name="tableRowClassName">
        <el-table-column v-for="(item, index) in tableTitleList" :key="index" :label="item.label" :prop="item.prop"
          :min-width="item.width" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="item.prop === 'sort'">
              {{ scope.row.sort }}
            </div>
            <div v-if="item.prop === 'companyName'" class="account-opening">
              <p v-if="!scope.row.isMod">
                {{ scope.row.companyName }}
              </p>
              <el-input v-else v-model="scope.row.companyName" class="white" placeholder="请输入">
              </el-input>
            </div>
            <div v-if="item.prop === 'companyCode'" class="account-opening">
              <p v-if="!scope.row.isMod">
                {{ scope.row.companyCode }}
              </p>
              <el-input v-else v-model="scope.row.companyCode" class="white" placeholder="请输入">
              </el-input>
            </div>
            <div v-if="item.prop === 'bankAccount'" class="account-opening">
              <p v-if="!scope.row.isMod">
                {{ scope.row.bankAccount }}
              </p>
              <el-input v-else v-model="scope.row.bankAccount" class="white" placeholder="请输入">
              </el-input>
            </div>
            <div v-if="item.prop === 'bankName'" class="bank-name">
              <p v-if="!scope.row.isMod">
                {{ scope.row.bankName }}
              </p>
              <el-input v-else v-model="scope.row.bankName" class="white" placeholder="请输入">
              </el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.id" :disabled="!scope.row.status" class="btn-text mod-btn" type="text"
              @click="mod(scope.row)">编辑</el-button>
            <el-button v-if="scope.row.isMod" class="btn-text" type="text" @click="saveBankAccountNumber(scope.row)">保存</el-button>
            <el-button v-if="scope.row.isMod" class="btn-text" type="text" @click="cancel(scope.$index, scope.row)">取消</el-button>
            <el-button v-if="!scope.row.status && scope.row.id" class="btn-text" type="text" @click="open(scope.row)">开启</el-button>
            <el-button v-if="scope.row.status && scope.row.id" class="btn-text" type="text" @click="close(scope.row)">关闭</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="add-account" @click="addBankAccountNumber">
        <el-icon class="el-icon-plus"></el-icon>
        添加账号
      </div>
    </div>
  </div>
</template>

<script>
import { getDecimal, getFourDecimal, modifyNetTitle } from "common/js/util";
import InvoiceInfo from "models/invoice-info";
import TaxRateMixins from "common/mixins/tax-rate";
export default {
  mixins: [TaxRateMixins],
  data() {
    return {
      // 汇率
      exchangeRate: null,
      tableTitleList: [
        { label: '序号', prop: 'sort', width: '' },
        { label: '公司名称', prop: 'companyName', width: '' },
        { label: '公司编码', prop: 'companyCode', width: '' },
        { label: '开户账号', prop: 'bankAccount', width: '' },
        { label: '开户银行', prop: 'bankName', width: '' }
      ],
    }
  },

  created() {
    modifyNetTitle('进出仓开票信息')
    this.initTaxRateList()
    this.initExchangeRate()
    this.initBankAccountNumberList()
  },

  methods: {

    /** 
     * @description 汇率率详情
    */
    initExchangeRate() {
      InvoiceInfo.getExchangeRate().then(res => {
        if (res.success) {
          this.exchangeRate = res.result
        } else {
          this.$message.error(res.message);
        }
      });
    },

    tableRowClassName({ row }) {
      if (!row.status) {
        return "close-row";
      }
    },

    /** 
     * @description 新增税率
    */
    addTaxRate() {
      let obj = {
        taxRate: ''
      }
      this.taxRateList.push(obj)
    },

    /** 
     * @description 删除税率
     * @param {number} index 索引
    */
    delTaxRate(index) {
      this.taxRateList.splice(index,1)
    },

    /**
     * @description 限制税率
     * @param {number} index 索引
     * @param {string} num 输入的税率
    */
    inputTaxRate(index, num) {
      let taxRate = getDecimal(num);
      this.taxRateList[index].taxRate = taxRate;
    },


    /**
     * @description 保存税率
    */
    saveTaxRate() {
      let taxRateList = []
      let isFlag = false
      this.taxRateList.map(i => {
        if (!i.taxRate) isFlag = true
        taxRateList.push(i.taxRate)
      })
      if (isFlag) return this.$message.error('请输入税率');
      let data = {
        taxRateList
      }
      InvoiceInfo.postSaveTaxRate(data).then(res => {
        if (res.success) {
          this.$message.success('保存税率成功')
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * @description 限制汇率
     * @param {string} num 输入的汇率
    */
    inputExchangeRate(num) {
      let exchangeRate = getFourDecimal(num);
      this.exchangeRate = exchangeRate;
    },

    /**
     * @description 保存汇率
    */
    saveExchangeRate() {
      if (!this.exchangeRate) return this.$message.error('请输入汇率');
      let data = {
        exchangeRate: this.exchangeRate?Number(this.exchangeRate):0
      }
      InvoiceInfo.postSaveExchangeRate(data).then(res => {
        if (res.success) {
          this.$message.success('保存汇率成功')
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * @description 添加银行账号
    */
    addBankAccountNumber() {
      let index = this.bankAccountNumberList.length + 1
      let obj = {
        sort: index < 10 ? `0${index}` : index,
        companyName: '',
        companyCode: '',
        bankName: '',
        bankAccount: '',
        isMod: true
      }
      this.bankAccountNumberList.push(obj)
    },

    /**
     * @description 编辑银行账号
    */
    mod(row) {
      row.isMod = true
    },

    open(row) {
      this.commonFun(row)
    },

    close(row) {
      this.commonFun(row)
    },

    commonFun(row) {
      InvoiceInfo.postUpdateBankAccountNumberStatus(row.id).then(res => {
        if (res.success) {
          this.initBankAccountNumberList();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    cancel(index, row) {
      if (row.id) {
        row.isMod = false
      } else {
        this.bankAccountNumberList.splice(index,1)
      }
    },

    /**
     * @description 保存银行账号
     */
    saveBankAccountNumber(row) {
      let data = {
        companyName: row.companyName,
        companyCode: row.companyCode,
        bankName: row.bankName,
        bankAccount: row.bankAccount
      }
      if (row.id) {
        data.id = row.id
        InvoiceInfo.postModBankAccountNumber(row.id,data).then(res => {
          if (res.success) {
            this.initBankAccountNumberList();
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        InvoiceInfo.postAddBankAccountNumber(data).then(res => {
          if (res.success) {
            this.initBankAccountNumberList();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    }
  }
}
</script>

<style lang='scss'>
.invoice-info {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 20px;
  box-sizing: border-box;
  .invoice-info-title {
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    font-family: 'PingFang SC-Regular';
    padding-left: 3px;
    border-left: 3px solid #2E68EA;
  }
  // 税率
  .tax-rate {
    .tax-rate-title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 10px;
      .add-tax-rate {
        margin-left: 10px;
        font-weight: 400;
        font-size: 12px;
        color: #2E68EA;
        cursor: pointer;
        font-family: 'PingFang SC-Regular';
      }
    }
    .tax-rate-content {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .tax-rate-row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 50px;
        margin-bottom: 20px;
        .sort {
          padding: 2px 4.5px 2px 4.5px;
          margin-right: 4px;
          background: #2E68EA;
          border-radius: 2px;
          font-weight: 400;
          font-size: 12px;
          color: #FFFFFF;
          font-family: 'PingFang SC-Regular';
        }
        .el-input {
          width: 100px;
          .el-input__suffix {
            line-height: 32px;
            height: 32px;
            top: 0px;
            right: 10px;
            font-weight: 400;
            font-size: 12px;
            color: #CCCCCC;
            font-family: 'PingFang SC-Regular';
          }
        }
        .del-tax-rate {
          margin-left: 10px;
          font-weight: 400;
          font-size: 12px;
          color: #2E68EA;
          cursor: pointer;
          font-family: 'PingFang SC-Regular';
        }
      }
      .tax-rate-row:last-of-type {
        margin-right: 0px;
      }
    }
  }
  // 汇率
  .exchange-rate {
    margin-top: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
    .exchange-rate-input {
      width: 294px;
      margin-right: 20px;
    }
  }
  .add-account {
    width: 100%;
    height: 36px;
    line-height: 36px;
    text-align: center;
    box-sizing: border-box;
    border: 1px dashed #2E68EA;
    font-family: 'PingFang SC-Regular';
    font-weight: 400;
    font-size: 14px;
    color: #2E68EA;
    cursor: pointer;
    margin: 10px 0px 20px 0px;
    .el-icon-plus {
      font-weight: 600;
    }
  }
  .table {
    margin-top: 8px;
  }
  .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
    height: 44px;
    line-height: 44px;
  }
  .table .el-table .el-table__body-wrapper .el-table__body .close-row td .cell {
    color: #999999;
    font-family: 'PingFang SC-Regular';
    .el-button.mod-btn {
      color: #999999;
      font-size: 14px;
    }
  }
}
</style>
